import { List, Bell } from '@phosphor-icons/react'
import { Link } from 'react-router-dom'
import { useSite } from '../../context/SiteContext'
import { useAuth } from '../../context/AuthContext'
import LangToggle from '../LangToggle/LangToggle'

const unreadNotifications = 2;

export default function Topbar({ setSidebarOpen }) {
  const { site } = useSite()
  const { user } = useAuth()

  return (
    <header className="topbar">
      <div className="topbar__left">
        <button
          className="topbar__menu-btn"
          onClick={() => setSidebarOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          <List size={22} />
        </button>
        {site && (
          <span className="topbar__site-name">{site.name}</span>
        )}
      </div>
      <div className="topbar__right">
        <LangToggle />
        <Link to="/notifications" className="topbar__icon-btn" aria-label="Notifications">
          <Bell size={18} />
          {unreadNotifications > 0 && <span className="topbar__notif-dot" />}
        </Link>
        <Link to="/profile" className="topbar__avatar" aria-label="Profile">
          {user?.initials ?? 'U'}
        </Link>
      </div>
    </header>
  )
}
